import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import routes from '@/presentation/components/Routes/routingMap';

import { Creators as procedureActions } from '@/domain/useCases/procedures/getProcedureInformation';
import GraduatedCertificateView from './GraduatedCertificateView';
import useProfile from '@/presentation/hooks/useProfile';

const GraduatedCertificateViewController = () => {
  const history = useHistory();
  const { academic } = useProfile();
  const dispatch = useDispatch();

  const [showNotAvailableModal, setShowNotAvailableModal] = useState(false);
  const [defaultErrorModal, setDefaultErrorModal] = useState(false);
  const [showProcedureExists, setShowProcedureExists] = useState(false);

  const {
    procedure: procedureSelectedInfo,
    isLoading,
    error
  } = useSelector((state: any) => state.procedureInformation);

  const getProcedurenfo = (studentType: 'EGRE' | '') => {
    if (!procedureSelectedInfo && !isLoading)
      dispatch(procedureActions.getProcedureInformation(1040, studentType));
  };

  useEffect(() => {
    if (academic) {
      const { isGraduated } = academic;
      getProcedurenfo(isGraduated ? 'EGRE' : '');
    }
  }, [academic]);

  const handleExistRequest = () => {
    if (procedureSelectedInfo?.requestInProgress) {
      setShowProcedureExists(true);
      return;
    }
    if (procedureSelectedInfo?.error !== null) {
      setDefaultErrorModal(true);
      return;
    }

    if (procedureSelectedInfo?.disabled) {
      setShowNotAvailableModal(true);
      return;
    }

    history.push(
      routes.student.procedures.categories.requests.GraduatedCertificate
        .register
    );
  };

  const handlerBackButtonProcedures = () => {
    history.push('/tramites');
  };

  const handlerBackButton = () => {
    history.goBack();
  };
  return (
    <GraduatedCertificateView
      procedureSelectedInfo={procedureSelectedInfo}
      onBackButton={handlerBackButton}
      errorInfo={error}
      handleExistRequest={handleExistRequest}
      disabled={{
        showNotAvailableModal,
        setShowNotAvailableModal
      }}
      error={{
        defaultErrorModal,
        setDefaultErrorModal
      }}
      ProcedureExists={{
        showProcedureExists,
        setShowProcedureExists
      }}
      handlerBackButtonProcedures={handlerBackButtonProcedures}
    />
  );
};
export default GraduatedCertificateViewController;
